import { useState, useEffect } from 'react'
// redux
import { useSelector } from 'react-redux'
// axios
import enhancedAxios from '../../utils/axiosUtils/enhancedAxios'
// mui
import { Box, Autocomplete, TextField } from '@mui/material'
import { errorAlert } from '../../utils/alerts'

const CategoryFilterBox = ({ filterValues, setFilterValues }) => {
    const userToken = useSelector((state) => state.userToken) // user token from redux store
    const [value, setValue] = useState('')
    const [categories, setCategories] = useState([])
    // get all categoreis
    useEffect(() => {
        // get all Citites to make select box with this cities
        enhancedAxios(null, userToken)
            .get(
                '/categories?sorts=-created_at&filters=parent_id:8236cf2c-1eae-4192-90e8-8567dd6fd42a,is_disabled:eq:false&page=1&paginate=10000'
            )
            .then((response) => {
                setCategories(response.data.data)
            })
            .catch((error) => errorAlert(error))
    }, [])
    // -------------------------------- handleAutoCompleteChange ------------------------------------------
    const handleAutoCompleteChange = (e, newValue) => {
        if (newValue != null) {
            setFilterValues({
                ...filterValues,
                categoryFilterValue: `category_id:${newValue.id}`,
            })
        } else {
            setFilterValues({
                ...filterValues,
                categoryFilterValue: ``,
            })
        }
    }
    return (
        <Box>
            <Autocomplete
                disablePortal
                options={categories}
                getOptionLabel={(option) => option.name ?? ''}
                onChange={handleAutoCompleteChange}
                // defaultValue={value}
                filterSelectedOptions
                sx={{
                    width: '100%',
                }}
                renderInput={(params) => {
                    return <TextField {...params} label="الفئة" />
                }}
            />
        </Box>
    )
}

export default CategoryFilterBox
